import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=f480a6a8&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=f480a6a8&prod&lang=scss&scoped=true"
import style1 from "./pay.vue?vue&type=style&index=1&id=f480a6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f480a6a8",
  null
  
)

export default component.exports